import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { compose } from 'redux';

import { reloadViewer } from 'common/actions/viewer';
import LoginForm from 'common/auth/LoginForm';
import { LocationContext } from 'common/containers/RouterContainer';
import { ViewerContext } from 'common/containers/ViewerContainer';
import connect from 'common/core/connect';
import LazyLoadedImage from 'common/LazyLoadedImage';
import devURL from 'common/util/devURL';
import withContexts from 'common/util/withContexts';

import 'css/components/auth/_Install.scss';

class Install extends Component {
  static propTypes = {
    location: PropTypes.shape({
      query: PropTypes.object,
    }),
    onSuccess: PropTypes.func,
    path: PropTypes.string,
    viewer: PropTypes.shape({
      _id: PropTypes.string,
      admin: PropTypes.bool,
    }),
  };

  componentDidMount() {
    const { location, viewer } = this.props;
    const { companyID } = location.query;
    if (!viewer || viewer.loggedOut) {
      return;
    } else if (!viewer.companies) {
      return;
    } else if (viewer.companies.length !== 1) {
      const company = viewer.companies.find((company) => company._id === companyID);
      if (!company) {
        return;
      }

      this.redirect(viewer, company);
      return;
    }

    const company = viewer.companies[0];
    this.redirect(viewer, company);
  }

  onCompanyLinkClick = (company, e) => {
    e.preventDefault();

    this.redirect(this.props.viewer, company);
  };

  onLoginSuccess = (user) => {
    if (!user || !user.companies || user.companies.length !== 1) {
      this.props.reloadViewer();
      return;
    }

    const company = user.companies[0];
    this.redirect(user, company);
  };

  redirect(user, company) {
    const { path, onSuccess } = this.props;

    // redirect handled by parent component
    if (onSuccess) {
      onSuccess(user, company);
      return;
    }

    if (company.integrationAuthRedirectionURL) {
      window.location.replace(devURL(company.integrationAuthRedirectionURL));
      return;
    }

    const companyURL = devURL(`https://${company.subdomain}.canny.io${path}`);
    window.location.replace(companyURL);
  }

  render() {
    const { viewer } = this.props;
    if (!viewer || viewer.loggedOut) {
      return (
        <div className="install">
          <div className="text">Log into your Canny account to set up this integration.</div>
          <LoginForm onSuccess={this.onLoginSuccess} />
        </div>
      );
    } else if (viewer.companies.length === 0) {
      return (
        <div className="install">
          <div className="text">Your Canny account isn't associated with a company account.</div>
          <LoginForm onSuccess={this.onLoginSuccess} />
        </div>
      );
    } else if (viewer.companies.length === 1) {
      // redirecting
      return <div />;
    } else {
      const { path } = this.props;
      const items = viewer.companies.map((company, i) => {
        const { subdomain } = company;
        const companyURL = devURL(`https://${subdomain}.canny.io${path}`);
        return (
          <a
            href={companyURL}
            key={company._id}
            className="companyLink"
            onClick={this.onCompanyLinkClick.bind(this, company)}>
            {company.logoURL ? (
              <LazyLoadedImage alt={`${company.name} logo`} src={company.logoURL} />
            ) : null}
            <div className="companyName">{company.name}</div>
          </a>
        );
      });
      return (
        <div className="install">
          <div className="text">Choose a Canny account to integrate with:</div>
          <div className="companyList">{items}</div>
        </div>
      );
    }
  }
}

export default compose(
  connect(null, { reloadViewer }, { forwardRef: true }),
  withContexts(
    {
      location: LocationContext,
      viewer: ViewerContext,
    },
    {
      forwardRef: true,
    },
  ),
)(Install);
